import { createContext, useContext } from 'react';
import { Breakstyle } from 'routes/Dashboard/components/WidgetsLayout/helpers';

export type WidgetPositionContextType = {
    currentBreakpoint: Breakstyle;
    md: {
        x: number;
        y: number;
        h: number;
        w: number;
    };
    xs: {
        x: number;
        y: number;
        h: number;
        w: number;
    };
    userInitialYPosition: number;
};

const WidgetPositionContext = createContext<WidgetPositionContextType>({
    currentBreakpoint: 'md',
    md: {
        x: 0,
        y: 0,
        h: 0,
        w: 0,
    },
    xs: {
        x: 0,
        y: 0,
        h: 0,
        w: 0,
    },
    userInitialYPosition: 0,
});

export const useWidgetPositionContext = () => useContext(WidgetPositionContext);
export const WidgetPositionContextProvider = WidgetPositionContext.Provider;
